<template>
    <div>
        <div class="calltoaction"
            :class="{ 'calltoaction--small-text': smalltext, 'calltoaction--offborder': offborder }">
            <div class="calltoaction__area--info">
                <slot name="above"/>
                <h1 class="calltoaction__title" v-html="title"></h1>
                <slot name="bellow"/>
            </div>
            <div class="calltoaction__area--image">
                <img :src="illustration"
                     class="calltoaction__image"
                     :title="alt"
                     :alt="alt">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'calltoaction',
    props: {
        illustration: {
            required: true,
            type: String,
        },
        title: {
            required: true,
            type: String,
        },
        alt: {
            default: "",
            type: String,
        },
        smalltext: {
            default: false,
            type: Boolean,
        },
        offborder: {
            default: false,
            type: Boolean,
        }
    }
}
</script>

<style lang="scss">
@import '../assets/css/vars';
.calltoaction__title br {
  @media(max-width: $max-xs) {
    display: none
  }
}
</style>

<style lang="scss" scoped>
@import '../assets/css/vars';

.calltoaction {

    $root: &;

    display: grid;
    grid-template-areas: "info image";
    height: 100vh;
    grid-template-columns: 1.1fr .9fr;
    @media(max-width: $max-sm) and (min-width: $min-sm){
      height: 50vh;
    }
    @media(max-width: $max-xs) {
        grid-template-columns: 1fr;
        grid-template-areas: "info" "image";
    }

    &--small-text {
        grid-template-columns: .35fr .75fr;
        @media(max-width: $max-sm) and (min-width: $min-sm){
          grid-template-columns: 1fr 1fr;
        }
        @media(max-width: $max-xs) {
            grid-template-columns: 1fr;
        }
    }

    &--offborder {
        height: 73vh;
        padding-top: .9rem;
        @media(max-width: $max-sm) and (min-width: $min-sm){
          height: 50vh;
        }
        @media(max-width: $max-xs) {
            height: 72.7rem;
        }
    }

    &__title {
        font-size: 6rem;
        font-weight: 900;
        line-height: 7.2rem;
        margin: 0 0 4rem;
        @media(max-width: $max-sm) and (min-width: $min-sm){
          font-size: 2.8rem;
          line-height: 3.5rem;
        }
        @media(max-width: $max-xs) {
            font-size: 2.5rem;
            line-height: 3rem;
            text-align: center;
        }
        #{$root}--small-text & {
          font-size: 5rem;
          line-height: 6rem;
          @media(max-width: $max-sm) and (min-width: $min-sm){
            font-size: 4rem;
            line-height: 6rem;
          }
          @media(max-width: $max-xs) {
                font-size: 3rem;
                margin-bottom: 2.3rem;
                text-align: left;
                line-height: 3.6rem;
          }
        }
    }

    &__area--info {
        grid-area: info;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    &__area--image {
        grid-area: image;
        position: relative;
    }

    &__image {
        height: 78.5vh;
        margin-top: -39.25vh;
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 5;
        @media(max-width: $max-sm) and (min-width: $min-sm) {
          height: 40vh;
          margin-top: -20vh;
          left: 5rem;
        }
        @media(max-width: $max-xs) {
            position: relative;
            width: 115%;
        }
        @media(max-width: $max-xs) and (orientation: landscape) {
            top: 15rem;
        }
        #{$root}--offborder & {
            height: 100vh;
            margin-top: 0;
            left: 7rem;
            top: -28vh;
            @media(max-width: $max-sm) and (min-width: $min-sm) {
              height: 40vh;
              top: 5vh;
            }
            @media(max-width: $max-xs) {
                height: 34.9rem;
                left: -4rem;
                top: 4rem;
            }
        }
    }
}
</style>
